import { THEME } from './theme-config';
export const API_URL = `${process.env.REACT_APP_REST_API_HOST}`;
export const API_PAYMENT_PROCESSOR_URL = `${process.env.REACT_APP_REST_PAYMENT_PROCESSOR_API_HOST}`;
export const LOGO_URL = 'finpos-platform-logo-url';
export const SMALL_LOGO_URL = 'finpos-platform-samll-logo-url';
export const PERMISSION_KEY = 'finpos-platform-permissions';
export const MENU_KEY = 'finpos-platform-menus';
export const JWT_TOKEN = 'finpos-platform-token';
export const OTP_TOKEN = 'finpos-platform-otp-token';
export const LOGGED_IN_USER = 'finpos-platform-user';
export const USER_FULL_NAME = 'finpos-platform-fullName';
export const USER_ID = 'finpos-platform-userId';
export const ENFORCE_PASSWORD_CHANGE = 'finpos-platform-enforce-password-change';
export const ENFORCE_TYPE = 'finpos-platform-enforceType';
export const LANGUAGE_KEY = 'finpos-platform-language';
export const PAGE_SIZE = 10;
export const PAGE_SIZE_LARGE = 20;
export const PAGE_SIZE_EXTRA_LARGE = 50;
export const DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
export const SEARCH_DATE_FORMAT = 'MM-DD-YYYY';
export const DISPATCH_DATE_FORMAT = 'MM/DD/YYYY';
export const CUSTOM_FIELD_DATE_FORMAT = 'YYYY-MM-DD';
export const PENDING_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const CERT_DATE_FORMAT = 'YYYY-MM-DD';
export const SWITCH_TIME_FORMAT = 'HH:mm';
export const CHANNEL_TIME_FORMAT = 'HH:mm:ss';
export const memberBankUser = 'memberBankUser';
export const SELECTED_OPTIONAL_APPS_STORAGE_KEY = 'installedApps.selectedOptionalApps';

let date = new Date();
let year = date.getFullYear();

const APP_CONFIG = THEME[process.env.REACT_APP_THEME || 'FINPOS'];

//regex
export const numberRegex = RegExp(/^[0-9]*$/);

export default APP_CONFIG;

export const sendingDateFormat = 'YYYY-MM-DD';

export const ENTITY_PARENTNAME = 'irh-entity-parentName';
export const ENTITY_NAME = 'irh-entity-name';
